import { useLang } from "hooks/useLang"
import useLocalStorage from "hooks/useLocalStorage"
import useWindowSize from "hooks/useWindowSize"
import { FiHeart } from "react-icons/fi"
import { PiShareFat } from "react-icons/pi"
import { IFinalEvent } from "types/event"
import * as gtag from "./../../../lib/gtag"
import { twMerge } from "tailwind-merge"
import { useState } from "react"
import ShareComponent from "./share/shareComponent"
import Modal from "react-modal"
interface IProps {
    event: IFinalEvent
    iconsSize: number
    className?: string
}

const ShareAndLike = ({
    event,
    iconsSize,
    className: customClassName,
}: IProps) => {
    // const { multiLangVars } = useLang()
    const [favoriteEvents, setFavoriteEvents] = useLocalStorage<IFinalEvent[]>("favouriteEvents", [])

    //if value exists and typeof value is string, clear it
    if (favoriteEvents && typeof favoriteEvents === "string") {
        setFavoriteEvents([])
    }

    const customStyles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 60,
            overflow: "hidden",
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            padding: 0,
            overflow: "auto",
        },
    }

    const [isShareComponentOpen, setIsShareComponentOpen] = useState(false)

    // Handle modal open/close to toggle body scroll
    const handleModalOpen = () => {
        setIsShareComponentOpen(true)
        document.body.style.overflow = "hidden"
    }

    const handleModalClose = () => {
        setIsShareComponentOpen(false)
        document.body.style.overflow = "unset"
    }

    const { isMobile } = useWindowSize()
    const handleMobileShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: "PassTickets",
                    url: window.location.href,
                })
            } catch (error) {
                console.error("Error sharing:", error)
            }
        } else {
            alert("Web Share API not supported in this browser.")
        }
    }

    const checkFavourite = Array.isArray(favoriteEvents) && favoriteEvents.some((favEvent) => favEvent._id === event?._id)

    const like = () => {
        if (checkFavourite) {
            const newFavouriteEvents = favoriteEvents.filter(
                (item) => item._id !== event?._id
            )
            setFavoriteEvents(newFavouriteEvents)
        } else {
            setFavoriteEvents([...favoriteEvents, event])
            gtag.event({
                action: "like",
                category: "event",
                label: "like_event",
                value: `${event?._id}`,
            })
        }
    }

    var currentUrl = ""

    if (typeof window !== "undefined") {
        // Get the current URL
        currentUrl = window.location.href
    }

    const onShare = async () => {
        gtag.event({
            action: "share",
            category: "event",
            label: "share_event",
            value: `${event?._id}`,
        })

        if (isMobile) {
            await handleMobileShare()
            return
        } else {
            handleModalOpen()
        }
    }

    const { lang } = useLang()
    const eventTitle = lang === "ar" ? event?.ar_title : event?.en_title
    return (
        <>
            <div className="flex flex-row items-center justify-center gap-5 px-3 lg:px-0">
                <FiHeart
                    onClick={like}
                    size={iconsSize}
                    fill={checkFavourite ? "#FD0058" : "transparent"}
                    className={twMerge(
                        "cursor-pointer transition-all active:scale-75",
                        checkFavourite
                            ? "scale-110 text-action-theme-400"
                            : "scale-100 text-primary-theme-500 dark:text-white",
                        customClassName
                    )}
                    style={{
                        filter:
                            checkFavourite && isMobile
                                ? "drop-shadow(0px 0px 10px #FD0058)"
                                : "drop-shadow(0px 0px 0px transparent)",
                    }}
                />
                <div className="relative">
                    <PiShareFat
                        onClick={onShare}
                        size={iconsSize}
                        className={twMerge(
                            `cursor-pointer text-primary-theme-500 transition-all active:scale-75 active:text-action-theme-400 dark:text-white`,
                            customClassName
                        )}
                    />
                </div>
            </div>

            <Modal
                onRequestClose={handleModalClose}
                isOpen={isShareComponentOpen}
                className="fixed inset-0 flex items-center justify-center z-50"
                style={customStyles}
                onAfterClose={() => {
                    document.body.style.overflow = "unset"
                }}
            >
                <div className="w-full max-w-2xl mx-auto p-4">
                    <ShareComponent
                        event_poster={event?.posters[0]}
                        event_name={eventTitle}
                        link={currentUrl}
                        setIsShareComponentOpen={setIsShareComponentOpen}
                    />
                </div>
            </Modal>
        </>
    )
}

export default ShareAndLike
